import { createFileRoute } from '@tanstack/react-router';
import { NActionIcon, NBgIcon, NButton, NTag } from '@next-is-free-monorepo/nif-web-components';
import { MoreHorizontalIcon, SendToMobile02Icon } from '@hugeicons/core-free-icons';
import BackButton from '../../../microcomponents/BackButton';
import NAvatar from '../../../../../libs/nif-web-components/src/microcomponents/NAvatar';

export const Route = createFileRoute('/_authenticated/design-system')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <div className={'p-10 space-y-4'}>
      <h2 className={'font-medium text-lg'}>XS Buttons</h2>
      <div className={'flex gap-2 border'}>
        <NButton size={'xs'}>Button</NButton>
        <NActionIcon size={'xs'} color={'outline'} strokeWidth={3} hugeIcon={MoreHorizontalIcon} />
        <NAvatar size={'xs'} text={'ciao'}/>
      </div>
      <h2 className={'font-medium text-lg'}>Buttons Small</h2>
      <div className={'border flex'}>
        <NButton size={'small'}>Button</NButton>
        <NButton size={'small'} color={'outline'}>Button</NButton>
        <NButton size={'small'}>Button</NButton>
        <NButton size={'small'}>Button</NButton>
        <NActionIcon size={'small'} color={'outline'} hugeIcon={MoreHorizontalIcon} />
        <NActionIcon size={'small'} color={'tertiary'} hugeIcon={SendToMobile02Icon} />
        <NActionIcon size={'small'} color={'secondary'} hugeIcon={SendToMobile02Icon} />
        <NActionIcon size={'small'} hugeIcon={SendToMobile02Icon} />
        <NBgIcon size={'small'} color={'secondary'} hugeIcon={SendToMobile02Icon} />
        <NAvatar size={'small'} text={'ciao'}/>
      </div>
      <h2 className={'font-medium text-lg'}>Buttons Medium</h2>
      <div className={'border flex'}>
        <NButton>Button</NButton>
        <NButton color={'secondary'}>Button</NButton>
        <NButton color={'tertiary'}>Button</NButton>
        <NButton color={'danger'}>Button</NButton>
        <NButton color={'outline'}>Button</NButton>
        <NButton color={'link'}>Button</NButton>
        <NButton color={'transparent'}>Button</NButton>
        <NButton color={'dangerOutline'}>Button</NButton>
        <NButton color={'dangerTransparent'}>Button</NButton>
        <NActionIcon color={'outline'} hugeIcon={MoreHorizontalIcon} />
        <NActionIcon color={'tertiary'} hugeIcon={SendToMobile02Icon} />
        <NActionIcon color={'secondary'} hugeIcon={SendToMobile02Icon} />
        <NActionIcon hugeIcon={SendToMobile02Icon} />
        <NAvatar text={'ciao'}/>
      </div>
      <h2 className={'font-medium text-lg'}>Buttons Big</h2>
      <div className={'border flex'}>
        <NButton size={'large'}>Button</NButton>
        <NButton size={'large'} color={'outline'}>Button</NButton>
        <NButton size={'large'}>Button</NButton>
        <NButton size={'large'}>Button</NButton>
        <NActionIcon size={'large'} color={'outline'} hugeIcon={MoreHorizontalIcon} />
        <NActionIcon size={'large'} color={'tertiary'} hugeIcon={SendToMobile02Icon} />
        <NActionIcon size={'large'} color={'secondary'} hugeIcon={SendToMobile02Icon} />
        <NActionIcon size={'large'} hugeIcon={SendToMobile02Icon} />
        <NAvatar size={'large'} text={'ciao'}/>
      </div>
      <div>
        <h2 className={'font-medium text-lg'}>Buttons Colors</h2>
        <div className={'border flex'}>
          <NButton>Button</NButton>
          <NButton color={'secondary'}>Button</NButton>
          <NButton color={'tertiary'}>Button</NButton>
          <NButton color={'danger'}>Button</NButton>
          <NButton color={'outline'}>Button</NButton>
          <NButton color={'link'}>Button</NButton>
          <NButton color={'transparent'}>Button</NButton>
          <NButton color={'dangerOutline'}>Button</NButton>
          <NButton color={'dangerTransparent'}>Button</NButton>
        </div>
        <div className={'border flex'}>
          <NActionIcon hugeIcon={SendToMobile02Icon} >Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} color={'secondary'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} color={'tertiary'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} color={'danger'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} color={'outline'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} color={'link'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} color={'transparent'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} color={'dangerOutline'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} color={'dangerTransparent'}>Button</NActionIcon>
        </div>
      </div>
      <div>
        <h2 className={'font-medium text-lg'}>Buttons Loading</h2>
        <div className={'border flex'}>
          <NButton loading>Button</NButton>
          <NButton loading color={'secondary'}>Button</NButton>
          <NButton loading color={'tertiary'}>Button</NButton>
          <NButton loading color={'danger'}>Button</NButton>
          <NButton loading color={'outline'}>Button</NButton>
          <NButton loading color={'link'}>Button</NButton>
          <NButton loading color={'transparent'}>Button</NButton>
          <NButton loading color={'dangerOutline'}>Button</NButton>
          <NButton loading color={'dangerTransparent'}>Button</NButton>
        </div>

        <div className={'border flex'}>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading color={'secondary'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading color={'tertiary'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading color={'danger'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading color={'outline'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading color={'link'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading color={'transparent'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading color={'dangerOutline'}>Button</NActionIcon>
          <NActionIcon hugeIcon={SendToMobile02Icon} loading color={'dangerTransparent'}>Button</NActionIcon>
        </div>
      </div>
      <div>
        <h2 className={'font-medium text-lg'}>Buttons disabled</h2>
        <div className={'border flex'}>
          <NButton disabled>Button</NButton>
          <NButton disabled color={'secondary'}>Button</NButton>
          <NButton disabled color={'tertiary'}>Button</NButton>
          <NButton disabled color={'danger'}>Button</NButton>
          <NButton disabled color={'outline'}>Button</NButton>
          <NButton disabled color={'link'}>Button</NButton>
          <NButton disabled color={'transparent'}>Button</NButton>
          <NButton disabled color={'dangerOutline'}>Button</NButton>
          <NButton disabled color={'dangerTransparent'}>Button</NButton>
        </div>
      </div>
      <div>
        <h2>Indicators</h2>
        <div>
          <NTag color={'primary'}>Primary</NTag>
          <NTag color={'primary'} type={'dot'}>Primary</NTag>
          <NTag color={'primary'} type={'light'}>Primary</NTag>
          <NTag color={'secondary'}>secondary</NTag>
          <NTag color={'secondary'} type={'dot'}>secondary</NTag>
          <NTag color={'secondary'} type={'light'}>secondary</NTag>
          <NTag color={'tertiary'}>tertiary</NTag>
          <NTag color={'tertiary'} type={'dot'}>tertiary</NTag>
          <NTag color={'tertiary'} type={'light'}>tertiary</NTag>
          <NTag color={'info'}>tertiary</NTag>
          <NTag color={'info'} type={'dot'}>tertiary</NTag>
          <NTag color={'info'} type={'light'}>tertiary</NTag>
          <NTag color={'success'}>tertiary</NTag>
          <NTag color={'success'} type={'dot'}>tertiary</NTag>
          <NTag color={'success'} type={'light'}>tertiary</NTag>
          <NTag color={'error'}>tertiary</NTag>
          <NTag color={'error'} type={'dot'}>tertiary</NTag>
          <NTag color={'error'} type={'light'}>tertiary</NTag>
        </div>
        <div>
          <NBgIcon color={'primary'} hugeIcon={SendToMobile02Icon} />
          <NBgIcon color={'secondary'} hugeIcon={SendToMobile02Icon} />
          <NBgIcon color={'tertiary'} hugeIcon={SendToMobile02Icon} />
          <NBgIcon color={'info'} hugeIcon={SendToMobile02Icon} />
          <NBgIcon color={'error'} hugeIcon={SendToMobile02Icon} />
          <NBgIcon color={'success'} hugeIcon={SendToMobile02Icon} />
        </div>
      </div>
    </div>
  );
}
